"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PlaceholderImage = PlaceholderImage;
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireWildcard(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _reactI18next = require("react-i18next");

var _noop = _interopRequireDefault(require("lodash/noop"));

var _AttachmentIcon = _interopRequireDefault(require("../AttachmentIcon"));

var _CheckCircle = _interopRequireDefault(require("@material-ui/icons/CheckCircle"));

var _RadioButtonUnchecked = _interopRequireDefault(require("@material-ui/icons/RadioButtonUnchecked"));

var _filesize = _interopRequireDefault(require("filesize"));

var Checkbox = function Checkbox(_ref) {
  var checked = _ref.checked,
      onChange = _ref.onChange;

  var handleChange = function handleChange(event) {
    event.stopPropagation();
    onChange({
      target: {
        checked: !checked
      }
    });
  };

  return checked ? /*#__PURE__*/_react["default"].createElement(_CheckCircle["default"], {
    fontSize: "small",
    color: "primary",
    onClick: handleChange
  }) : /*#__PURE__*/_react["default"].createElement(_RadioButtonUnchecked["default"], {
    fontSize: "small",
    onClick: handleChange
  });
};

var Status = {
  ERROR: -1,
  LOADING: 0,
  LOADED: 1
};

function PlaceholderImage(_ref2) {
  var src = _ref2.src,
      alt = _ref2.alt,
      rest = (0, _objectWithoutProperties2["default"])(_ref2, ["src", "alt"]);

  var _useState = (0, _react.useState)(Status.LOADING),
      _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
      status = _useState2[0],
      setStatus = _useState2[1];

  var _useTranslation = (0, _reactI18next.useTranslation)(),
      t = _useTranslation.t;

  (0, _react.useEffect)(function () {
    var image = new Image();

    image.onload = function () {
      return setStatus(Status.LOADED);
    };

    image.onerror = function () {
      return setStatus(Status.ERROR);
    };

    image.src = src;
  }, [src]);
  if (status === Status.LOADING) return null;
  return /*#__PURE__*/_react["default"].createElement("img", (0, _extends2["default"])({}, rest, {
    alt: alt,
    src: status === Status.LOADED ? src : t('placeholder-photo.png')
  }));
}

var CardSize = {
  NORMAL: 'normal',
  LARGE: 'large'
};
var CardDimension = {
  normal: {
    width: 155,
    height: 105
  },
  large: {
    width: 320,
    height: 115
  }
};

var AttachmentCard = function AttachmentCard(_ref3, ref) {
  var _ref3$attachment = _ref3.attachment,
      attachment = _ref3$attachment === void 0 ? {} : _ref3$attachment,
      _ref3$src = _ref3.src,
      src = _ref3$src === void 0 ? '' : _ref3$src,
      _ref3$selected = _ref3.selected,
      selected = _ref3$selected === void 0 ? false : _ref3$selected,
      _ref3$onSelect = _ref3.onSelect,
      onSelect = _ref3$onSelect === void 0 ? _noop["default"] : _ref3$onSelect,
      _ref3$onClick = _ref3.onClick,
      onClick = _ref3$onClick === void 0 ? _noop["default"] : _ref3$onClick,
      _ref3$size = _ref3.size,
      size = _ref3$size === void 0 ? CardSize.NORMAL : _ref3$size;

  var handleOnClick = function handleOnClick(e) {
    e.stopPropagation();
    onClick();
  };

  var name = attachment.name,
      contentType = attachment.contentType,
      attachmentSize = attachment.size;

  var headerNode = /*#__PURE__*/_react["default"].createElement("div", {
    className: "pt-1 flex items-center justify-center"
  }, /*#__PURE__*/_react["default"].createElement(_AttachmentIcon["default"], {
    colored: true,
    contentType: contentType || 'others',
    fileName: name,
    style: {
      fontSize: '2rem'
    }
  }), /*#__PURE__*/_react["default"].createElement("span", {
    className: "text-xs ml-2"
  }, (0, _filesize["default"])(attachmentSize)));

  var bodyNode = /*#__PURE__*/_react["default"].createElement("div", {
    className: "overflow-hidden whitespace-normal break-words font-semibold text-xs text-center",
    style: {
      lineClamp: 2,
      height: 36
    }
  }, name);

  var bottomNode = /*#__PURE__*/_react["default"].createElement("div", {
    className: "flex-1 flex justify-end"
  }, onSelect && /*#__PURE__*/_react["default"].createElement(Checkbox, {
    checked: selected,
    onChange: onSelect
  }));

  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "p-1 relative rounded-lg shadow overflow-hidden inline-flex flex-col text-gray-medium flex-shrink-0 flex-grow-0 m-2 cursor-pointer hover:bg-secondary dark:bg-secondary",
    style: CardDimension[size],
    onClick: handleOnClick,
    ref: ref
  }, src ? /*#__PURE__*/_react["default"].createElement("div", {
    className: "flex items-center justify-center flex-1 overflow-hidden"
  }, /*#__PURE__*/_react["default"].createElement(PlaceholderImage, {
    key: src,
    src: src,
    alt: name,
    className: "w-full h-full object-cover"
  })) : headerNode, /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _classnames["default"])({
      'mx-8 py-2': size === CardSize.LARGE
    })
  }, bodyNode), bottomNode);
};

var _default = /*#__PURE__*/(0, _react.forwardRef)(AttachmentCard);

exports["default"] = _default;
//# sourceMappingURL=index.js.map